import { getPreferredPhone, useGetAllContacts } from "@api/contactService";
import MaestroLoader from "@components/MaestroLoader";
import { useMutation, useQuery } from "@tanstack/react-query";
import { authenticatedApi } from "api";
import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
// import GridLayout from "react-grid-layout";
import GridLayout, { Responsive, WidthProvider } from "react-grid-layout";
import Sheet from '@mui/joy/Sheet';
import DashboardWidget from '@components/widgets/DashboardWidget';
import { Box, Button, ButtonGroup, Checkbox, Grid, Stack, Switch, Tooltip, Typography } from '@mui/joy';
import Dropdown from '@mui/joy/Dropdown';
import IconButton from '@mui/joy/IconButton';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemContent from '@mui/joy/ListItemContent';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListDivider from '@mui/joy/ListDivider';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import DashboardWidthProvider from '@providers/DashboardWidthProvider';
import { useDocumentTitle, useWindowSize } from '@uidotdev/usehooks';
import Subheader from '@components/layout/Subheader';
import { useAuth } from '@providers/AuthProvider';

import Table from '@mui/joy/Table';
import EnhancedTableHead from "@components/EnhancedTableHead";
import Paginate from "@components/Paginate";
import CreateNewButton from "@components/CreateNewButton";
import ToggleViewMode from "@components/ToggleViewMode";
import ToggleMultiSelect from "@components/ToggleMultiSelect";
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import EditButton from "../EditButton";
import { ObjectContext } from "@providers/ObjectProvider";
import pluralize from 'pluralize';
import UnrecoverableError from "@components/UnrecoverableError";
import { CheckPermission } from "@components/CheckPermission";

export default function ObjectShow({
    query,
    // type,
    permissionType = null,
    title,
    subtitleKey = 'name',
    headerActions = null,
    color,
    canEdit = null,
    // columns,
    // listCell,
    // listActions = () => {},
    // defaultParams:_defaultParams = { order: 'asc', orderby: 'name', page: 1, view: 'active' },
    children = <></>,
}) {
    // useDocumentTitle(`${title} | Maestro Community Manager`);

    const { id } = useParams();

    const {user, can} = useAuth();

    const {
        // isPending,
        isLoading,
        isError,
        error,
        data,
        isFetching,
        isPreviousData,
        dataUpdatedAt,
    } = query(parseInt(id), {
        retry: false,
    });

    const pageTitle = data?.name ?? data?.address ?? `View ${pluralize.singular(title ?? '')}`;

    useDocumentTitle(`${pageTitle} | Maestro Community Manager`);

    const hasPermissionToEdit = () => {
        if(canEdit !== null) {
            return canEdit({data});
        }

        if(!permissionType) {
            return true;
        }

        return can([`edit basic ${permissionType}`, `edit ${permissionType}`]);
    }

    if(isLoading || isError) {
        return (<>
            <Subheader
                title={title}
                // subtitle={''}
                tint={color}
            >
                {/* This icon button is used as placeholder to keep the page from changing height */}
                <IconButton
                    size="sm"
                    color="neutral"
                    variant="outlined"
                    sx={{ bgcolor: 'background.surface', opacity: 0, pointerEvents: 'none' }}
                >
                    <ChevronRightRoundedIcon />
                </IconButton>
            </Subheader>
            {isLoading && (
                <MaestroLoader centered/>
            )}
            {isError && (
                <UnrecoverableError status={404} />
            )}
        </>
        );
    }

    const providerValue = {
        ...data,
        query_dataUpdatedAt: dataUpdatedAt,
    };

    return (<>
        <Subheader
            title={title}
            subtitle={data[subtitleKey] ?? ''}
            tint={color}
        >
            <Stack sx={{gap: 1, flexDirection: 'row'}}>
                <ObjectContext.Provider value={providerValue}>
                    <ButtonGroup
                        size="sm"
                        color="neutral"
                        variant="outlined"
                    >
                        {headerActions}
                        {/* <CheckPermission permissions={!permissionType ? true : [`edit basic ${permissionType}`, `edit ${permissionType}`]}> */}
                        {hasPermissionToEdit() === true && (
                            <EditButton/>
                        )}
                        {/* </CheckPermission> */}
                    </ButtonGroup>
                </ObjectContext.Provider>
            </Stack>
        </Subheader>
        <ObjectContext.Provider value={providerValue}>
            <Box sx={theme => ({
                backgroundImage: color && `linear-gradient(180deg, ${theme.palette[color][100]} 0%, white 100%);`,// : null,
                backgroundAttachment: 'fixed',
                height: '100%',
                p: 2,
            })}>
                <Grid container columns={12} gap={2}>
                    {children}
                </Grid>
            </Box>
        </ObjectContext.Provider>
    </>);

}
